import Chart from "../../../../src/client/katnh/interactions/chart/Chart.js";
import * as React from 'react';
export default {
  Chart,
  React
};